import { GetFeedsQueryParamsV2 } from "@fartherfinance/frontend/api/Notifications/requests/getFeeds.v2";
import { FeedStatus } from "@fartherfinance/frontend/api/Notifications/Types";
import { SortOrder } from "@fartherfinance/frontend/api/Types";

export const FEEDS_DEFAULT_QUERY_PARAMS: GetFeedsQueryParamsV2 = {
  sort: `${SortOrder.Descending}createdTs`,
  filterByStatus: [FeedStatus.Values.UNREAD, FeedStatus.Values.READ],
  pageSize: 25,
  // NOTE: page query param needs to be static as it's altered by react-query internally
  page: 1,
};
